import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { Country, CountryService } from "../../countries/shared";
import { Reseller, ResellerFilterPipe } from "../shared";

import { SlugPipe } from "@atenea-cms";

@Component({
  selector: "reseller-filter-bar",
  templateUrl: "./reseller-filter-bar.component.html",
  styleUrls: ["./reseller-filter-bar.component.scss"],
  providers: [CountryService, ResellerFilterPipe, SlugPipe],
})
export class ResellerFilterBarComponent implements OnInit {
  @Input() items: Array<Reseller> = [];
  @Input() itemsFiltered: Array<Reseller> = [];
  @Input() reorder: boolean = false;
  @Output() itemsFilteredChange: EventEmitter<any> = new EventEmitter();
  @Output() reorderChange: EventEmitter<any> = new EventEmitter();

  private resellerTypes: Array<any> = [];
  private countries: Country[];
  private name: string;
  private type: number;
  private country: String;

  constructor(
    private countryService: CountryService,
    private resellerFilterPipe: ResellerFilterPipe
  ) {}

  ngOnInit() {
    this.resellerTypes = [
      { value: 1, name: "Distribuidor" },
      { value: 2, name: "Tienda" },
    ];

    this.loadFilters();

    this.countryService.getAll().subscribe((countries) => {
      this.countries = countries;

      if (Array.isArray(this.items)) {
        this.filterItems();
      }
    });
  }

  changeMode() {
    this.name = "";

    if (this.reorder === false) {
      this.type = 0;
      this.country = null;
    } else {
      this.type = this.resellerTypes[0].value;
      this.country = this.countries[0]._id;
    }

    this.filterItems();
    this.reorderChange.emit(this.reorder);
  }

  private filterItems() {
    this.itemsFiltered = this.resellerFilterPipe.transform(
      this.items,
      this.name,
      this.type,
      this.country
    );

    this.itemsFiltered.sort(
      (a: Reseller, b: Reseller) => a.position - b.position
    );
    this.itemsFilteredChange.emit(this.itemsFiltered);

    this.saveFilters();
  }

  loadFilters() {
    const filters: any = JSON.parse(
      localStorage.getItem("resellersListFilters")
    );

    if (filters && Object.keys(filters).length) {
      this.name = filters.name;
      this.type = filters.type;
      this.country = filters.country;
    }
  }

  saveFilters() {
    const data: any = {
      name: this.name,
      type: this.type,
      country: this.country,
    };

    localStorage.setItem("resellersListFilters", JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/reseller-filter-bar/reseller-filter-bar.component.ts